import { TranslatableText } from '@dreryk/react-common';
import { ContentCopyIcon, IconSize, IconWrapper, SidePanelContentSlotLink } from '@dreryk/react-components';

import { useVisitFormSyncing } from '../../visit/form/VisitFormSynchronization.hooks';

type HistoricalVisitContentSlotCopyLinkProps = {
   readonly onClick: VoidFunction;
   readonly label: TranslatableText;
};

export const HistoricalVisitContentSlotCopyLink = (props: HistoricalVisitContentSlotCopyLinkProps): JSX.Element => {
   const visitFormSyncing = useVisitFormSyncing();

   return (
      <SidePanelContentSlotLink
         testId={'copy'}
         icon={
            <IconWrapper size={IconSize.SMALL} testId={'copy'} disabled={visitFormSyncing}>
               <ContentCopyIcon />
            </IconWrapper>
         }
         onClick={props.onClick}
         label={props.label}
         disabled={visitFormSyncing}
      />
   );
};
